import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SectionMainTitle from "../common/SectionMainTitle";
import ApplyNowButton from "../common/ApplyNowButton";
import ParallaxBackground from "../common/ParallaxBackground";

interface HeroParallaxSectionProps {
  sectionLabel: string;
  title?: string;
  subtitle?: string;
  backgroundImage?: string;
  ctaLabel?: string;
  ctaLink?: string;
  showButton?: boolean;
  showTitleResponsive?: boolean;
}

const HeroParallaxSection: React.FC<HeroParallaxSectionProps> = ({
  sectionLabel,
  title,
  subtitle,
  backgroundImage = "/assets/team1.jpeg",
  showButton = true,
  showTitleResponsive = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ParallaxBackground
      backgroundImage={backgroundImage}
      minHeight="50vh"
      centerContent
    >
      <Container sx={{ position: "relative", zIndex: 2, mt: 0 }}>
        <SectionMainTitle title={sectionLabel} align="center" />
        {showTitleResponsive && (
          <Typography
            variant={isMobile ? "h5" : "h2"}
            fontWeight={600}
            align={isMobile ? "left" : "center"}
            sx={{ mt: isMobile ? 1 : 3 }}
          >
            {title}
          </Typography>
        )}
        <Typography
          variant={isMobile ? "h6" : "h5"}
          align={isMobile ? "left" : "center"}
          sx={{ mt: isMobile ? 1 : 4 }}
        >
          {subtitle}
        </Typography>

        {showButton && (
          <Box
            sx={{
              display: "flex",
              justifyContent: isMobile ? "left" : "center",
              mt: isMobile ? 1 : 4,
            }}
          >
            <ApplyNowButton />
          </Box>
        )}
      </Container>
    </ParallaxBackground>
  );
};

export default HeroParallaxSection;
